import { getData } from "../../utils/serverHelper";
import { CUSTOMERS } from "../../utils/urls";
import { errorMessage } from "../error/action";
import { setErrorLeads, setLoadingLeads, setSuccessLeads } from "./reducer"


export const getLeads = async(dispatch,query='',page=1)=>{
    try {
        dispatch(setLoadingLeads());
        const data = await getData(CUSTOMERS+'/leads?size=10&query='+query+'&page='+page);
        dispatch(setSuccessLeads(data.data));
    } catch (error) {
        errorMessage(dispatch,error?.response?.data?.error?.message || 'Server is down. Please try after some times');
        dispatch(setErrorLeads(error?.response?.data?.error?.message || 'Server is down. Please try after some times'));
    }
}